'use client'

import React from 'react'

import { Spinner } from '@rewardops/ui'
import { ResponseItem } from '@rewardops/utils'

import { RETAILERS_SORT_OPTIONS } from '~/utils/sort-utils'
import { useApi } from '~/components/hooks/use-api'
import { PaginationInput } from '~/components/input/pagination-input'
import { GenericSortMenu } from '~/components/maple/filters/generic-sort-menu'
import { MobileTopFilters } from '~/components/maple/mobile-top-filters'
import { RetailerCard } from '~/components/maple/pages/retailers/retailers-card'
import { useTranslation } from '~/app/i18n/client'
import { RetailersSearchProps } from './retailers-search'

const MobileRetailersSearch = ({
  items,
  itemsTotal,
  sort,
  earnRatesFilterOptions,
  isFiltersLoading,
  isItemsLoading: loading,
}: RetailersSearchProps) => {
  const { t } = useTranslation()
  const { tenant } = useApi()

  const shouldDisplayFilters = () => {
    if (isFiltersLoading || loading) return false
    // Return true if earn rates filters are available and the feature is enabled.

    if (earnRatesFilterOptions && earnRatesFilterOptions?.length > 0)
      return tenant.flags?.earnRateFilterEnabled

    // Otherwise, return true if there are items and their total is greater than 0.
    return itemsTotal > 0
  }

  return (
    <div className="flex flex-col">
      {shouldDisplayFilters() ? (
        <MobileTopFilters
          earnRatesOptions={earnRatesFilterOptions}
          isPointsRangeEnabled={false}
        />
      ) : null}
      <div className="pt-2">
        {!loading ? (
          <div className="mx-3">
            <GenericSortMenu sortOptions={RETAILERS_SORT_OPTIONS} />
          </div>
        ) : null}

        <div className="mt-8">
          {loading ? (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          ) : itemsTotal !== 0 ? (
            <div className="grid auto-rows-fr grid-cols-2 md:grid-cols-3 md:gap-5">
              {items?.map((item: ResponseItem, index: number) => (
                <RetailerCard
                  key={`${index}_${item?.name}`}
                  item={item}
                  position={index}
                  listName="retailer_search"
                />
              ))}
            </div>
          ) : (
            <div className="px-2 lg:px-0">{t('general.noItems')}</div>
          )}
        </div>

        {!loading ? (
          <PaginationInput
            className="mt-12"
            totalNumberOfItems={itemsTotal}
            sortOption={sort}
          />
        ) : null}
      </div>
    </div>
  )
}

export default MobileRetailersSearch
